import { createTheme } from "@mantine/core";

export const theme = createTheme({
  defaultRadius: "md",
  transitions: {
    default: "all 0.3s ease",
  },
  shadows: {
    ydao: "0 4px 20px rgba(153, 69, 255, 0.15)",
    ydaoHover: "0 8px 32px rgba(153, 69, 255, 0.25)",
  },
});
